import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosClient = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});
// Add a request interceptor
axiosClient.interceptors.request.use(
    async (config) => {
        // Ensure headers is always defined
        if (!config.headers) {
            config.headers = {} as import('axios').AxiosRequestHeaders;
        }
        config.headers['language'] = localStorage.getItem('language') || 'vi';
        return config;
    },
    (error) => Promise.reject(error)
);
// Add a response interceptor
axiosClient.interceptors.response.use(
    function (response: AxiosResponse) {
        return response.data;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export { axiosClient };
